import React from 'react';
import PropTypes from 'prop-types';

import { Banner } from 'school-space-client/components';
import { getPluralNoun } from 'school-space-utils/string';

const css = theme => ({
    marginTop: theme.layout.baseline * 0.5
});

const RebookingBanner = ({ onClick, unreviewedBookings }) => (
    <Banner
        title="Bookings for the 2024/25 academic year are now open 🎉"
        message={`You have ${unreviewedBookings.length} ${getPluralNoun(
            unreviewedBookings,
            'booking'
        )} left to review by June 1st in order to keep your slots for next year. Click here
        for more details.`}
        ariaLabel="Open rebooking information modal"
        styles={css}
        onClick={onClick}
    />
);

RebookingBanner.propTypes = {
    onClick: PropTypes.func.isRequired,
    unreviewedBookings: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RebookingBanner;
